
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 3.215v-1l1.069-1.069a.5.5 0 01.77.077L4.5 3.715 2.236 5.98a.5.5 0 01-.85-.299L1 2.215v1c0 5.523 4.477 10 10 10h1l-3.466-.385a.5.5 0 01-.298-.85L10.5 9.715l2.493 1.662a.5.5 0 01.076.77L12 13.214h-1c-5.523 0-10-4.477-10-10z","fill":"#e2e5ed"}}),_c('path',{attrs:{"d":"M1 2.215v1c0 5.523 4.477 10 10 10h1m-11-11l1.069-1.069a.5.5 0 01.77.077L4.5 3.715 2.236 5.98a.5.5 0 01-.85-.299zm11 11l1.069-1.069a.5.5 0 00-.077-.77L10.5 9.717 8.236 11.98a.5.5 0 00.298.85z","stroke":"#e2e5ed","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    